module.exports = __webpack_public_path__ + "media/success.71527001.wav";